import { render, staticRenderFns } from "./CarouselsByInmo.vue?vue&type=template&id=554ac306"
import script from "./CarouselsByInmo.vue?vue&type=script&lang=js"
export * from "./CarouselsByInmo.vue?vue&type=script&lang=js"
import style0 from "./CarouselsByInmo.vue?vue&type=style&index=0&id=554ac306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports